import { getApiClient } from '@plandi/common'
interface SupportData {
  name: string
  phone?: string
  email: string
  message: string
  companyName?: string
}

export const layoutApi = {
  async getSupportData(data: SupportData, locale: string) {
    const { data: data_1 } = await getApiClient(locale).post(
      'v1/support/contacting',
      data
    )
    return data_1
  }
}
